import React from 'react'
import Navbar from '../components/Navbar'
import Shop from '../components/Shop'
const Marketplace = () => {
    return (
        <div className=' bg-black text-white min-h-screen'>
            <Navbar />
            <Shop />

        </div>
    )
}

export default Marketplace
